import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { AppComponent } from '../app.component';

export const RouterStates : Array<NgHybridStateDeclaration> = [
  {
    component : AppComponent,
    name      : 'app',
    redirectTo: 'app.login',
    resolve   : [
      {
        deps     : [ '$translate' ],
        resolveFn: ( $translate : ng.translate.ITranslateService ) => $translate.onReady(),
        token    : 'translationsReady'
      },
    ],
    url: '?disconnect',
  }
];
